import React from 'react';
import { Box, Button, Chip, CircularProgress, Typography } from '@mui/material';
import { DownloadCardRoot } from './styles';
import { WindowsIcon, MacIcon, DownloadArrowIcon } from './icons';

export default function DownloadCard({ platform, info, recommended, downloading, onDownload }) {
    const isWindows = platform === 'windows';
    const hasUrl = !!(info?.url && info.url.trim());
    return (
        <Button
                variant="contained"
                fullWidth
                disabled={!hasUrl || downloading}
                onClick={() => hasUrl && onDownload(platform, info.url)}
                aria-label={`Download Exam Browser for ${isWindows ? 'Windows' : 'macOS'}`}
                startIcon={hasUrl && !downloading && <DownloadArrowIcon />}
                sx={{
                    backgroundColor: hasUrl ? '#3B5FC4' : undefined,
                    color: '#fff',
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.9rem',
                    padding: '11px 20px',
                    mb: 2,
                    '&:hover': { backgroundColor: '#2F4FAD' },
                    '&.Mui-disabled': { backgroundColor: '#E5E7EB', color: '#9CA3AF' },
                }}
            >
                {downloading
                    ? <CircularProgress size={17} sx={{ color: '#fff' }} />
                    : hasUrl
                        // ? `Download (${isWindows ? '.exe' : '.dmg'})`
                        ? `Download`
                        : 'Coming Soon...'
                }
            </Button>
        // <DownloadCardRoot recommended={recommended ? 'true' : 'false'}>
        //     {recommended && (
        //         <Chip
        //             label="RECOMMENDED FOR YOU"
        //             size="small"
        //             sx={{
        //                 position: 'absolute',
        //                 top: -13,
        //                 left: 20,
        //                 backgroundColor: '#2563EB',
        //                 color: '#FFFFFF',
        //                 fontSize: '0.6rem',
        //                 fontWeight: 700,
        //                 letterSpacing: '0.07em',
        //                 height: 24,
        //                 borderRadius: '20px',
        //                 px: 0.5,
        //             }}
        //         />
        //     )}

        //     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
        //         {isWindows ? <WindowsIcon size={26} /> : <MacIcon size={26} />}
        //         <Box>
        //             <Typography fontWeight={700} fontSize="1.05rem" lineHeight={1.2}>
        //                 {isWindows ? 'Windows' : 'macOS'}
        //             </Typography>
        //             <Typography variant="caption" color="text.secondary">
        //                 {isWindows ? 'Windows 10 & 11 · 64-bit' : 'macOS 12 or later'}
        //             </Typography>
        //         </Box>
        //     </Box>

        //     <Button
        //         variant="contained"
        //         fullWidth
        //         disabled={!hasUrl || downloading}
        //         onClick={() => hasUrl && onDownload(platform, info.url)}
        //         aria-label={`Download Exam Browser for ${isWindows ? 'Windows' : 'macOS'}`}
        //         startIcon={hasUrl && !downloading && <DownloadArrowIcon />}
        //         sx={{
        //             backgroundColor: hasUrl ? '#3B5FC4' : undefined,
        //             color: '#fff',
        //             borderRadius: '10px',
        //             textTransform: 'none',
        //             fontWeight: 600,
        //             fontSize: '0.9rem',
        //             padding: '11px 20px',
        //             mb: 2,
        //             '&:hover': { backgroundColor: '#2F4FAD' },
        //             '&.Mui-disabled': { backgroundColor: '#E5E7EB', color: '#9CA3AF' },
        //         }}
        //     >
        //         {downloading
        //             ? <CircularProgress size={17} sx={{ color: '#fff' }} />
        //             : hasUrl
        //                 ? `Download (${isWindows ? '.exe' : '.dmg'})`
        //                 : 'Coming Soon...'
        //         }
        //     </Button>

        //     {info?.version && (
        //         <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', pt: 0.5 }}>
        //             <Typography variant="caption" color="text.secondary">Version</Typography>
        //             <Typography variant="caption" color="text.secondary" fontWeight={500}>{info.version}</Typography>
        //         </Box>
        //     )}
        // </DownloadCardRoot>
    );
}
